module.exports = __webpack_public_path__ + "static/media/IMG_0098.3750f29c.jpg";